export default "__VITE_ASSET__DBYLkY03__"